import React from "react";
import {Box, Heading, Form, FormField, TextInput, Button, CheckBox, FileInput, Select} from "grommet";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useLazyQuery,useMutation } from '@apollo/client';
import {extractIdFormData, GOLF_ADD_ATTACHMENT, GOLF_GET_ATTACHMENT, QUERY_CONTENT_TYPE} from "../../../utilis/utils";
import moment from "moment";
import {QUERY_SERVICE_AREA_LIST, UPSERT_SERVICE} from "./ServiceGQL.js";
import {QUERY_AREE} from "../clubmatePackage/PackageGQL.js";

export default function AddService(props) {

  const [formData,setFormData]=React.useState()
  const [mutationUpsertPack]=useMutation(UPSERT_SERVICE);
  const [areeList,setAreeList] = React.useState([]);
  const [selectedAree,setSelectedAree] = React.useState([]);
  const [ queryGetAree
  ]  = useLazyQuery(QUERY_AREE, {
  fetchPolicy: "no-cache",
    onCompleted: (data) => {
      if(data["clubmate_clubmatearea_clubmatearea"]){
        setAreeList(data["clubmate_clubmatearea_clubmatearea"]);
      }
    },
    onError:(error)=>{
      console.log(error);
    },
    notifyOnNetworkStatusChange: true, // did the work
  });
   const [ queryServiceList
  ]  = useLazyQuery(QUERY_SERVICE_AREA_LIST, {
  fetchPolicy: "no-cache",
    onCompleted: (data) => {
      if(data["clubmate_clubmatearea_clubmatearea"]){
        setSelectedAree(data["clubmate_clubmatearea_clubmatearea"]);
      }
    },
    onError:(error)=>{
      console.log(error);
    },
    notifyOnNetworkStatusChange: true, // did the work
  });

    function onUpsertService(){
    let obj= extractIdFormData(formData,true,true);
    delete obj?.variables?.input["_Typename"]
    obj.variables.input["aree"]=JSON.stringify(selectedAree.map((area)=>area?.id))
      if(obj.variables.input["partnerandnotpartner"]){
        obj.variables.input["visibleForPartner"]=null;
      }
      if(obj.variables.input["visibleforpartner"]){
        obj.variables.input["visibleForPartner"]=obj.variables.input["visibleforpartner"];
      }
      delete obj.variables.input["partnerandnotpartner"];
      delete obj.variables.input["visibleforpartner"];

    mutationUpsertPack(obj)
    .then((value)=>{
      //setFormData(value.data[`${tenant}`][`upsertUser${tenantTypeFirstUpperCase}`])
      alert("Servizio aggiunto correttamente");
      onEscLayer();
    }).catch((value)=>{
      console.error(value);
      alert("Errore durante l'operazione");
    })
  }

  React.useEffect(() =>{
      queryGetAree();
      if(props?.elementSel){
        queryServiceList({variables:{serviceId:props?.elementSel?.id}});
        setFormData(props?.elementSel)
      }
    },[])

  function onEscLayer(){
    if(props.onEscLayer){
        props.onEscLayer();
    }
    setFormData({});
  }

  const onChangeTextInput=(event)=>{
    if(event.target.type==="number"){
      setFormData({...formData,[event.target.name]:parseFloat(event.target.value)})
    }else if(event.target.type==="date"){
      setFormData({...formData,[event.target.name]:moment(event.target.value).format("YYYY-MM-DD")})
    }else{
      setFormData({...formData,[event.target.name]:event.target.value})
    }
  }

  function handleChange(option){
    setSelectedAree(option);
  }

  return (
    <Box height="100%" round pad="medium" direction="column" background="#ffffff" align="center" overflow="auto">
      <Heading level="2" margin="none" size="small" style={{fontWeight:'bold',textTransform: 'uppercase'}}>
        <Box direction="row" gap="large">
          {!props.elementSel?"Inserisci servizio":"Aggiorna servizio"}
          {/*<Button label="Scarica modello" href={"./modelliCsv/Modello_Personale.csv"} style={{width:'200px',fontSize:'20px',background:'#f8b20e',color:'white',fontWeight:'bold',textTransform: 'uppercase',textAlign:"center"}}></Button>  */}
        </Box>
      </Heading>
      <Box fill gap="medium" pad={{ vertical: "small" }} align="center">
        <Form style={{marginTop:"50px"}}>
        <Box direction="row" align="center">
          <Box pad="xsmall">
            <FormField required label="Nome">
              <TextInput
                style={{fontWeight:"bold"}}
                name="name"
                value={formData?.name}
                onChange={e => onChangeTextInput(e)}
              />
            </FormField>
          </Box>
          <Box pad="xsmall">
            <FormField required label="Prezzo">
              <TextInput
                style={{fontWeight:"bold"}}
                placeholder="es. 10,5"
                type="number"
                name="price"
                value={formData?.price}
                onChange={e => onChangeTextInput(e)}
              />
            </FormField>
          </Box>
        </Box>
        <Box  direction="row" gap="medium" style={{marginTop:15+"px"}}>
          <Autocomplete
            multiple
            disablePortal
            id="aree"
            value={selectedAree}
            getOptionKey={(option) => option?.id}
            getOptionLabel={(option) => option?.name}
            options={areeList}
            sx={{ width: 300 }}
            renderInput={(params) => <TextField {...params} label="Aree del servizio" />}
            onChange={(event, value) => handleChange(value)}
          />
        </Box>
          <Box direction="column" margin={"large"} gap={"small"}>
            <CheckBox
                style={{fontWeight:"bold"}}
                name="partner"
                checked={formData?.visible_for_partner || false}
                label="Partner"
                onChange={(e) => setFormData({...formData,visible_for_partner:e.target.checked})}
            />
            <CheckBox
                style={{fontWeight:"bold"}}
                name="partnerAndNotPartner"
                checked={formData?.partnerAndNotPartner || formData?.visible_for_partner===null}
                label="Visibile a partner e non partner"
                onChange={(e) => setFormData({...formData,partnerAndNotPartner:e.target.checked})}
            />
            <CheckBox
                style={{fontWeight:"bold"}}
                name="archive"
                checked={formData?.archive || false}
                label="Archivia servizio"
                onChange={(e) => setFormData({...formData,archive:e.target.checked})}
            />
            <CheckBox
                style={{fontWeight:"bold"}}
                name="entrance_service"
                checked={formData?.entrance_service || false}
                label="Servizio di ingresso per non soci"
                onChange={(e) => setFormData({...formData,entrance_service:e.target.checked})}
            />
            <CheckBox
                style={{fontWeight:"bold"}}
                name="request_entrance_for_use"
                checked={formData?.request_entrance_for_use || false}
                label="Richiedi ingresso per utilizzarlo"
                onChange={(e) => setFormData({...formData,request_entrance_for_use:e.target.checked})}
            />
          </Box>
      </Form>
      <Box direction="row" gap="medium" alignSelf="center" style={{marginTop:"20px"}}>
          <Button label={!props.elementSel?"Aggiungi":"Aggiorna"} onClick={onUpsertService} style={{width:'170px',height:'34px',fontSize:'18px',background:'#f8b20e',color:'white',fontWeight:'bold',textTransform: 'uppercase'}}/>
      </Box>
      </Box>
    </Box>
  )
}